export default function Header({ title, info }) {
  return (
    <header className="mb-8">
      <h1 className="font-oswald text-3xl md:text-3xl font-bold text-gray-900 mb-3 tracking-tight">
        {title}
      </h1>
      <h4 className="font-poppins text-sm md:text-base text-gray-600 leading-relaxed">
        {info}
      </h4>
    </header>
  );
}